module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0044.jpg?v=a9f065d9";